export default __webpack_public_path__ + "static/media/Resources.ca1d6c0d.svg";